/**
 * Using for recomendation products and recent view products
 */
if (!customElements.get('sub-categories')) {
  customElements.define(
    'sub-categories',
    class SubCategories extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          slider: '.sub-categories__swiper',
          sliderWrapper: '.sub-categories__swiper-wrapper'
        }
        
        // Using this method for desktop scroll https://discourse.wicg.io/t/drag-to-scroll-a-simple-way-to-scroll-sideways-on-desktop/3627/
        this.isDown = false;
        this.startX = 0;
        this.scrollLeftStart = 0;
        this.isDragging = false;

        //bind methods
        this._handleMouseDown = this._handleMouseDown.bind(this);
        this._handleMouseLeave = this._handleMouseLeave.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleClick = this._handleClick.bind(this);
        this._handleScroll = this._handleScroll.bind(this);
      }

      connectedCallback() {
        if (!this.slider) {
          this.slider = this.querySelector(this.selectors.slider);
        }
        if (!this.sliderWrapper) {
          this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        }
        this.slider?.addEventListener('mousedown', this._handleMouseDown);
        this.slider?.addEventListener('mouseup', this._handleMouseUp);
        this.slider?.addEventListener('mouseleave', this._handleMouseLeave);
        this.slider?.addEventListener('mousemove', this._handleMouseMove);
        this.slider?.addEventListener('click', this._handleClick);
        this.slider?.addEventListener('scroll', this._handleScroll);
        this._handleScroll();
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('mousedown', this._handleMouseDown);
        this.slider?.removeEventListener('mouseup', this._handleMouseUp);
        this.slider?.removeEventListener('mouseleave', this._handleMouseLeave);
        this.slider?.removeEventListener('mousemove', this._handleMouseMove);
        this.slider?.removeEventListener('click', this._handleClick);
        this.slider?.removeEventListener('scroll', this._handleScroll);
      }

      _handleMouseDown(e) {
        this.isDown = true;
        this.startX = e.pageX - this.slider.offsetLeft;
        this.scrollLeftStart = this.slider.scrollLeft;
      }

      _handleMouseLeave() {
        this.isDown = false;
        this.isDragging = false;
        this.slider.classList.remove('grabbing');
      }

      _handleMouseUp() {
        this.isDown = false;
        this.slider.classList.remove('grabbing');
      }

      _handleMouseMove(e) {
        if (!this.isDown) return;
        e.preventDefault();

        const x = e.pageX - this.slider.offsetLeft;
        const walk = x - this.startX;
        this.slider.scrollLeft = this.scrollLeftStart - walk;

        //only switch to dragging mode if the user has moved at least a couple pixels
        //(otherwise, can interrupt clicking)
        if(!this.isDragging && Math.abs(walk) > 2) {
          this.isDragging = true;
          this.slider.classList.add('grabbing');
        } 
      }

      _handleClick(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        e.preventDefault();
        e.stopPropagation();
      }

      _handleScroll() {
        if (!this.sliderWrapper) return;

        const scrollLeft = this.slider.scrollLeft;
        const offsetLeft = this.sliderWrapper.offsetLeft;
        const maxX = this.sliderWrapper.clientWidth - this.slider.clientWidth + offsetLeft;
        
        //check if left scroll out of view
        if (scrollLeft > offsetLeft) {
          this.classList.add('off-left');
        } else {
          this.classList.remove('off-left');
        }

        //check if right scroll out of view
        if (scrollLeft < maxX) {
          this.classList.add('off-right');
        } else {
          this.classList.remove('off-right');
        }
      }
    }
  );
}
